/* import __COLOCATED_TEMPLATE__ from './offset-tempco.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();